module.exports = __webpack_public_path__ + "img/機械雲運作架構圖.1019abd1.png";